<template>
  <div>
    <div class="flex justify-between mb-4">
      <p class="font-medium">MESSAGES</p>
      <input
          type="text"
          v-model="searchTerm"
          placeholder="Search messages..."
          class="px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>

    <div class="border rounded-lg shadow-sm bg-white">
      <div v-if="filteredMessages.length > 0" class="overflow-x-auto">
        <table class="min-w-full bg-white rounded-lg shadow-md">
          <tbody>
          <tr
              v-for="message in filteredMessages"
              :key="message.id"
              class="border-t hover:bg-gray-50 transition"
          >
            <td class="px-6 py-4">
              <p class="text-gray-400">{{ message.sender }}</p>
              <div>
                <strong class="ml-1">{{ message.subject }}</strong>
              </div>
            </td>

            <td class="px-6 py-4 relative flex justify-end">
              <p class="px-6 py-4 text-sm text-gray-500">
                {{ formatDate(message.created_at) }}
              </p>
              <button
                  @click="openMenu(message.id)"
                  class="text-xl text-primary"
              >
                ⋮
              </button>
              <div
                  v-if="activeMenu === message.id"
                  class="absolute right-0 mt-2 w-32 bg-white border border-gray-300 rounded shadow-md z-10"
              >
                <button
                    class="block w-full text-left px-4 py-2 hover:bg-gray-100"
                    @click="reply(message.id)"
                >
                  Reply
                </button>
                <button
                    class="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-500"
                    @click="archiveMessage(message.id)"
                >
                  Archive
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="p-4 text-gray-500">No messages found.</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue"
import api from "@/services/api";

const messages = ref([])
const searchTerm = ref("")
const activeMenu = ref(null)

const fetchMessages = async () => {
  const res = await api.get("/messages", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  })
  messages.value = res.data
}

const archiveMessage = async (id) => {
  console.log("archive called");
  await api.post(
      `/messages/${id}/archive`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
  )
  fetchMessages()
}


const filteredMessages = computed(() => {
  if (!searchTerm.value) return messages.value
  return messages.value.filter(
      (m) =>
          (m.sender?.toLowerCase() || "").includes(searchTerm.value.toLowerCase()) ||
          (m.subject?.toLowerCase() || "").includes(searchTerm.value.toLowerCase())
  )
})


function formatDate(dateString) {
  const options = { year: "numeric", month: "short", day: "numeric" }
  return new Date(dateString).toLocaleDateString(undefined, options)
}

function openMenu(id) {
  activeMenu.value = activeMenu.value === id ? null : id
}

function reply(id) {
  alert(`Reply to message ${id}`)
}

onMounted(fetchMessages)
</script>
